import { Grid3x3, Infinity as InfinityIcon, Droplets, FileText } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const ICONS = [Grid3x3, InfinityIcon, Droplets, FileText];

export const Advantages = () => {
  const { t } = useLang();
  const a = t.advantages;

  return (
    <section id="advantages" className="bg-white border-b border-border" data-testid="advantages">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="max-w-3xl">
          <Reveal>
            <Overline index="03">{a.label}</Overline>
            <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-nero-ink leading-[1.05]">
              {a.title}
            </h2>
            <p className="mt-6 font-body text-lg leading-relaxed text-zinc-600">{a.subtitle}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
          {a.cards.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.07}>
                <div
                  className="group h-full bg-white border-b border-r border-border p-8 min-h-[280px] flex flex-col hover:bg-nero-ink transition-colors duration-300"
                  data-testid={`advantage-card-${i}`}
                >
                  <Icon className="h-8 w-8 text-nero-ink group-hover:text-nero-green transition-colors" strokeWidth={1.5} />
                  <div className="mt-auto pt-10">
                    <h3 className="font-heading text-2xl font-medium tracking-tight text-nero-ink group-hover:text-white transition-colors">
                      {c.title}
                    </h3>
                    <p className="mt-2 font-body text-sm leading-relaxed text-zinc-500 group-hover:text-white/60 transition-colors">
                      {c.text}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
